<template>
  <div class="vehicle-card">
    <div class="d-flex justify-content-between">
      <p class="vehicle-title font-heading">Peterbilt {{ vehicle.name }}</p>
      <p class="fuel-type text-uppercase font-heading">{{ vehicle.fuel.type }}</p>
    </div>
    <div class="image-container text-center my-2">
      <img :src="vehicle.icon" alt="Peterbilt {{ vehicle.name }}" class="img-fluid">
    </div>
    <div class="banner-default-active my-3">
      <img :src="vehicle.bannerAlt" :alt="vehicle.name" class="img-fluid d-flex mx-auto" style="max-height:61px">
    </div>
    <div class="vehicle-links d-flex justify-content-between mb-4 mr-5">
      <a v-if="vehicle.productInfo" :href="vehicle.resources" target="_blank" class="d-flex" @click="trackDownload(vehicle.name, vehicle.resources)"><span class="material-icons-outlined">info</span><span>&nbsp;Download Spec Sheet</span></a>
      
      <span class="video-modal-launch" data-toggle="modal" data-target="#video-modal" :data-src="vehicle.videoLink" :data-title="'Peterbilt '+ vehicle.name " @click="trackVideo(vehicle.name)">
        <img :src="`${imagePath}/red-arrow.png`" alt=" "> Play Video
      </span>
    </div>

    <!-- Reduce width -->
    <div class="text-left copy-body">
      <p class="vehicle-subheading mb-1"><strong>{{ vehicle.descriptionSubHead }}</strong></p>
      <p>{{ vehicle.descriptionDetails }}</p>
      <br>
      <a @click="toggleModal()" href="#" class="btn btn-outline-primary btn-lg btn-block" data-toggle="modal" data-target="#compare-vehicles">Compare Diesel VS. Electric</a>
      <br>
    </div>
  </div>

  <!-- VIDEO MODAL -->
  <div id="video-modal" class="modal-summary modal fade" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-heading text-uppercase">Peterbilt video Product Info</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span class="material-icons" aria-hidden="true">clear</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item" src="" frameborder="0" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>

  
  <VehicleCompareModal @modalClosed="toggleModal" v-if="modalActive" />



</template>

<script>
  import VehicleCompareModal from '../components/VehicleCompareModal'

  // all info needs to be dynamic based on vehicle selection
  export default {
    name: 'VehicleCard',
    props: {
      vehicle: {}
    },
    components: {
      VehicleCompareModal
    },
    data () {
      return {
        modalActive: false,
        imagePath: process.env.VUE_APP_ASSET_LOCATION
      }
    },
    mounted () {
      $('.video-modal-launch').on('click', function() {
        var modal = $('#video-modal')
        modal.find('iframe').attr('src', $(this).data('src'))
        modal.find('.modal-title').text($(this).data('title'))
      })

      $('#video-modal').on('hide.bs.modal', function (e) {
        $(this).find('iframe').attr('src','')
        $(this).find('.modal-title').text('')
      })
    },
    methods: {
      toggleModal() {
        this.modalActive = !this.modalActive
      },
      trackDownload(vehicleName, resource) {
        // Tracking
        window.gtag('event', 'Download', {
          'event_category': 'Cost Calculator - Vehicle Resource',
          'event_label': vehicleName
        })
      },
      trackVideo(vehicleName) {
        // Tracking
        window.gtag('event', 'Play', {
          'event_category': 'Cost Calculator - Vehicle Video',
          'event_label': vehicleName
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .vehicle-card {
    margin: auto;
    max-width: 500px;
  }
</style>